<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <!--<form class="h-100 scrollable" v-if="filteredContextList.length > 0">-->
  <form class="h-100 d-flex flex-column" v-if="filteredContextList.length > 0">
    <!--
    <options-form-field
      ref="contextSelector"
      class="mb-0"
      dropdown
      :value="selectedContext"
      :options="getOptions()"
      :value2id="context2id"
      :id2value="id2context"
      @input="selectContext($event)"
    />
    -->
    <b-row no-gutters>
      <options-form-field
        ref="contextSelector"
        class="mb-0 col-sm-9 col-10"
        dropdown
        :value="selectedContext"
        :options="getOptions()"
        :value2id="context2id"
        :id2value="id2context"
        @input="selectContext($event)"
      />
      <b-button
        v-if="selectedContext"
        variant="primary"
        class="col-sm-3 col-2"
        @click.prevent="$refs.messages.exportMessages()"
        ><!--:disabled="!canUpload()"-->
        <i class="fa fa-fw fa-download"></i>
        <span class="d-sm-inline-block d-none ml-1">{{
          $t("common.export")
        }}</span>
      </b-button>
    </b-row>
    <messages
      v-if="selectedContext"
      ref="messages"
      :disabled="!canPost()"
      :context="resolveContextServerPath(selectedContext)"
      :context-id="selectedContext.getId(value)"
      :subcontext="selectedContext.subcontext"
      class="flex-grow-1"
      ><!--class="h-100"
      style="margin-top: -2.5rem; padding-top: 2.5rem;"
      :external-context="selectedContext.externalContext"
      :external-context-id="selectedContext.getExternalContextId && selectedContext.getExternalContextId(value)"-->
      <b-alert
        variant="warning"
        show
        v-if="selectedContext && selectedContext.message"
        v-html="selectedContext.message"
        class="m-0"
      ></b-alert>
      <b-alert
        variant="danger"
        show
        v-if="selectedContext && !canPost()"
        class="m-0"
      >
        <!-- TODO i18n -->
        Puoi leggere i messaggi in questa chat ma non sei autorizzato ad
        inviarne di nuovi.
      </b-alert>
    </messages>
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import Messages from "./Messages";
import notifier from "@/services/NotificationService";
import { beep } from "core/utils";

/** This must be binded to the editor */
export function onMessage(msg) {
  console.log("MESSAGE", msg);
  if (this.currentTab.id !== "messages") {
    if (this.tabCounters.messages == undefined) {
      this.tabCounters = {
        ...this.tabCounters,
        messages: 1
      };
    } else {
      this.tabCounters.messages++;
    }
    beep();
  }
}

/** This must be binded to the editor */
export function onMessagesTabSelected() {
  if (this.tabCounters.messages == undefined) {
    this.tabCounters = {
      ...this.tabCounters,
      messages: 0
    };
  } else {
    this.tabCounters.messages = 0;
  }
}

export default {
  mixins: [EditorMixin],

  components: {
    Messages
  },

  props: {
    /**
     * [
     *   {
     *     name: CUSTOMER,
     *     label: 'Allegati cliente',
     *     serverPath: 'customers',
     *     getId: (value) => value.customer.id
     *   },
     *   {
     *     name: REQUEST,
     *     label: 'Allegati richiesta',
     *     serverPath: 'credit-assignments/requests',
     *     getId: (value) => value.id
     *   },
     * ]
     */
    contextList: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      counters: {},
      selectedContext:
        this.filteredContextList &&
        this.filteredContextList.length &&
        this.filteredContextList[0]
    };
  },

  computed: {
    filteredContextList() {
      return this.contextList.filter(
        c => c.getPermissions(this.value) && c.getPermissions(this.value).view
      );
    }
  },

  mounted() {
    this.selectedContext =
      this.filteredContextList &&
      this.filteredContextList.length &&
      this.filteredContextList[0];
    this.subscribe();
  },

  beforeDestroy() {
    this.unsubscribe();
  },

  methods: {
    getOptions() {
      return this.filteredContextList.map(this.context2option);
    },

    context2option(context) {
      const contextId = context.serverPath + "/" + context.subcontext;
      const count = this.counters[contextId];
      const countStr = count ? " (" + count + ")" : "";

      const ret = {
        value: contextId,
        text: context.label + countStr
      };
      // console.log('context2option(', context, ') = ', ret);
      return ret;
    },

    context2id(context) {
      const ret = context.serverPath + "/" + context.subcontext;
      // console.log('context2id(', context, ') = ', ret);
      return ret;
    },

    id2context(id) {
      const ret = this.filteredContextList.find(
        context => id === context.serverPath + "/" + context.subcontext
      );
      // console.log('id2context(', id, ') = ', ret);
      return ret;
    },

    canPost() {
      const permissions = this.selectedContext.getPermissions(this.value);
      //console.log('permissions', permissions);
      return permissions.post;
    },

    // =========================================================================

    resolveContextServerPath(c) {
      return c.serverPath;
    },

    subscribe() {
      //console.log("Subscribing", this.context, this.contextId);

      for (let c of this.filteredContextList) {
        const serverPath = this.resolveContextServerPath(c);

        const topic =
          "/" +
          serverPath +
          "/chat/" +
          c.getId(this.value) +
          "/" +
          c.subcontext;

        notifier.subscribe(
          topic,
          m => this.onMessageReceived(serverPath, c.subcontext, m),
          s => this.storeSubscription(s)
        );

        notifier.subscribePrivate(
          m => this.onMessageReceived(serverPath, c.subcontext, m),
          s => this.storeSubscription(s),
          topic
        );
      }
    },

    storeSubscription(s) {
      if (!this.subscriptions) {
        this.subscriptions = [];
      }
      this.subscriptions.push(s);
    },

    unsubscribe() {
      if (this.subscriptions) {
        console.log("Unsubscribing", this.subscriptions);
        for (let s of this.subscriptions) {
          s.unsubscribe();
        }
        this.subscriptions = undefined;
      }
    },

    onMessageReceived(context, subcontext, data) {
      console.log("Message received (ws) - ", context, subcontext, ":", data);
      if (
        this.$refs.messages.context === context &&
        this.$refs.messages.subcontext === subcontext
      ) {
        //console.log('Add message');
        this.$refs.messages.addMessage(data);
      } else {
        const contextId = context + "/" + subcontext;
        // console.log('Updating counter for ', contextId);
        if (this.counters[contextId] !== undefined) {
          this.counters[contextId]++;
        } else {
          const counters = { ...this.counters };
          counters[contextId] = 1;
          this.counters = counters;
        }
      }
      //this.messages.push(data);
      this.$emit("message", { context, subcontext, ...data });
      //beep();
    },

    selectContext(ctx) {
      const contextId = this.context2id(ctx);
      if (this.counters[contextId] !== undefined) {
        this.counters[contextId] = 0;
      } else {
        const counters = { ...this.counters };
        counters[contextId] = 0;
        this.counters = counters;
      }
      this.selectedContext = ctx;
    }
  }
};
</script>
